import React from 'react';
import { Form as FormikForm, Formik } from 'formik';
import { object, string } from 'yup';
import InputField from 'shared/components/InputField';

const validationSchema = object({
  name: string().required('Required'),
  description: string().required('Required'),
  comments: string().required('Required'),
});

const FormikFormComponent: React.FC = () => {
  return (
    <Formik
      initialValues={{
        description: '',
        name: '',
        comments: '',
      }}
      validationSchema={validationSchema}
      onSubmit={values => {}}>
      <FormikForm>
        <div className="mt-5">
          <h2>Input Field</h2>
          <div
            style={{ width: '100%', gap: '20px' }}
            className="mt-2 flex-inline">
            <InputField
              name="description"
              placeholderstring="Text Input"
              label="Description"
            />
            <InputField
              name="name"
              placeholderstring="Text Input"
              label="Name"
            />
            <InputField
              name="name"
              placeholderstring="Text Input"
              label="Name"
              addonbefore={'+1'}
            />

            <InputField
              textarea
              name="comments"
              placeholderstring="Text Input"
              label="comments"
            />
          </div>
        </div>
      </FormikForm>
    </Formik>
  );
};

export default FormikFormComponent;
